import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "profile" }
const _hoisted_2 = { class: "flex flex-col p-2 mx-2" }
const _hoisted_3 = { class: "w-full flex flex-col mb-3 items-center" }
const _hoisted_4 = { class: "flex w-full flex-col" }
const _hoisted_5 = { class: "self-end text-sm" }
const _hoisted_6 = { class: "self-start text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-500 flex justify-center mt-1"
}
const _hoisted_8 = { class: "flex w-full flex-col" }
const _hoisted_9 = { class: "self-start text-sm" }
const _hoisted_10 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_11 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_12 = { class: "flex flex-col gap-3" }
const _hoisted_13 = { class: "w-full flex items-center justify-center" }
const _hoisted_14 = { class: "w-full flex items-center justify-center" }
const _hoisted_15 = { class: "p-6 flex flex-col justify-center w-full" }
const _hoisted_16 = { class: "font-bold" }

import DbButton from "@/components/DB-Components/DbButton.vue";
import DbInput from "@/components/DB-Components/DbInput.vue";
import DbPasswordInput from "@/components/DB-Components/DbPasswordInput.vue";
import { UserData } from "@/data/interfaces/UserDataInterface";
import { reAuthorize } from "@/services/auth/re-auth";
import store from "@/store";
import router from "@/router";
import { computed, onMounted, ref } from "vue";
import {
  isFieldRequired,
  isFieldValid,
  validationMessage,
} from "@/utils/users/methods";
import AppModal from "@/components/AppModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

const user = ref({
  current_password: "",
  password: "",
  password_confirmation: "",
});

const form = ref({
  errors: {},
  processing: false,
  successful: false,
});

onMounted(() => {
  reAuthorize(store).then((res) => {
    store
      .dispatch("UserStore/getUser", store.state.user.data.user_id)
      .then((response) => {
        user.value = {
          ...(store.state.UserStore.user as UserData),
          ...user.value,
        };
      });
  });
});

const update = async () => {
  form.value.successful = false;
  form.value.processing = true;
  if (!isFormValid.value) {
    return;
  }
  await store
    .dispatch("UserStore/editUser", user.value)
    .then((res) => {
      form.value.successful = true;
    })
    .catch((error) => {
      form.value.successful = false;
      const data = error?.response?.data;
      const errorStatus = data?.httpCode;
      if (errorStatus == 403) {
        form.value.errors = data.httpMessage;
      }
    });
};

const isFormValid = computed(() => {
  let isFilled = true;

  if (form.value.processing == false) {
    const isFilled =
      (Object.keys(user.value) as Array<keyof typeof user.value>).filter(
        (fieldName) =>
          isFieldRequired(fieldName) &&
          (user.value[fieldName] == null || user.value[fieldName]?.length === 0)
      ).length > 0
        ? false
        : true;

    return isFilled;
  }

  return Object.keys(user.value).every((fieldName) =>
    isFieldValid(fieldName as any, user.value)
  );
});

const close = () => {
  router.push("/profile");
};

const clearErrors = () => {
  form.value.errors = {};
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("account.required")), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("account.confirm_current_password")), 1)
          ]),
          _createVNode(DbPasswordInput, {
            modelValue: user.value.current_password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.current_password) = $event)),
            placeholder: _ctx.$t('account.current_password') + '*',
            label: _ctx.$t('account.current_password') + '*',
            variant: "outline",
            onInput: clearErrors,
            class: "w-full hydrated",
            name: "password"
          }, null, 8, ["modelValue", "placeholder", "label"]),
          (form.value.errors.hasOwnProperty('current_password'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t(`account.validation.current_password_wrong`)), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mb-3" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("account.confirm_new_password")), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full flex flex-col items-center", {
          'pb-6': !form.value.processing || _unref(isFieldValid)('password', user.value),
          'pb-0': !_unref(isFieldValid)('password', user.value) && form.value.processing,
        }])
        }, [
          _createVNode(DbPasswordInput, {
            modelValue: user.value.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
            placeholder: _ctx.$t('account.password') + '*',
            label: _ctx.$t('account.password') + '*',
            ariainvalid: 
            !_unref(isFieldValid)('password', user.value) && form.value.processing ? 'true' : ''
          ,
            variant: "outline",
            class: "w-full hydrated",
            name: "password"
          }, null, 8, ["modelValue", "placeholder", "label", "ariainvalid"]),
          (!_unref(isFieldValid)('password', user.value) && form.value.processing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("account.validation.password")), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full flex flex-col items-center", {
          'pb-6':
            !form.value.processing || _unref(isFieldValid)('password_confirmation', user.value),
          'pb-0':
            !_unref(isFieldValid)('password_confirmation', user.value) && form.value.processing,
        }])
        }, [
          _createVNode(DbPasswordInput, {
            modelValue: user.value.password_confirmation,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password_confirmation) = $event)),
            placeholder: _ctx.$t('account.password_confirmation') + '*',
            label: _ctx.$t('account.password_confirmation') + '*',
            ariainvalid: 
            !_unref(isFieldValid)('password_confirmation', user.value) && form.value.processing
              ? 'true'
              : ''
          ,
            variant: "outline",
            class: "w-full hydrated",
            name: "password_confirmation"
          }, null, 8, ["modelValue", "placeholder", "label", "ariainvalid"]),
          (!_unref(isFieldValid)('password_confirmation', user.value) && form.value.processing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("account.validation.password_confirmation")), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(DbButton, {
              onClick: _cache[3] || (_cache[3] = () => _unref(router).push('/profile')),
              variant: "secondary-solid"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("account.cancel")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(DbButton, {
              onClick: update,
              disabled: !isFormValid.value,
              variant: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("account.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _createVNode(AppModal, {
      id: "reset-password-modal",
      visible: form.value.successful,
      "modal-size": "md",
      modalType: "accept",
      cancelText: "account.ok",
      onHideModal: close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "********", -1)),
          _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t("account.password_changed")), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})